<template>
    <div>
      <div class="mask" @click="none" :style="{'display':isShow?'block':'none'}"></div>
      <div class="rel" :style="{'display':isShow?'block':'none'}">
        <ul  :style="{'top':istop=='Video'?'5.25rem':'1rem'}">
          <li @click="toMore('all')"  :class="{'active':type==''}"><span>全部</span></li>
          <li @click="toMore(item.egId,item.egName)" v-for="item in allList" :key="item.egId" :class="{'active':type==item.egId}"><span>{{item.egName}}</span></li>
        </ul>
      </div>

      <div class="search">
        <div class="search_inp">
          <input type="text" placeholder="请输入视频名称/讲师姓名" v-model="title"><div @click="toMore(type,1)"><img src="../../assets/images/search.png" alt=""></div>
        </div>
        <div class="search_type">
          <span>分 类</span>
          <div @click="screenOut">
            <img src="../../assets/images/down.png" alt="">
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import bus from '../bus/index'
    export default {
        data() {
            return {
              isShow:false,
              title:'',
              type:'',
              allList:[],
              istop:this.$route.name,
              name:'',
            }
        },
        props: {},
        methods: {
          toMore(type,name){
            if((typeof type)=='number') {
              this.type = type;
              if(name!=1){
                this.title = '';
              }
            }else if(type=='all'){
              this.type = '';
              this.title = '';
            }

            let params = {
              title:this.title,
              type:this.type,
              order:"",
            };
            sessionStorage.setItem('ra_more',JSON.stringify(params));

            // console.log(params)
            bus.$emit('sendValue',params)
            // this.$emit('sendValue',params);
            if(this.$route.name!='Allvideo'){
              this.$router.push({
                name:'Allvideo',
                params:{
                  title:this.title,
                  type:this.type,
                },
              })
            }
            this.none();


          },
          none(){
            this.isShow = false;
          },
          screenOut(){
            this.isShow = !this.isShow;


          },
        },

        computed: {},
        mounted() {
          // console.log('搜索routename---',this.$route.name)
          // console.log('111---',this.$route.params.title)
          // console.log('222---',this.title)
          // console.log('mounted参数====',this.$route.params)
          if(this.$route.name=='Video'){
            this.title = '';
            this.type = '';
          }else{
            let date = JSON.parse(sessionStorage.getItem('ra_more'));
            this.title = date.title;
            this.type = date.type;
            // this.title = ''
          }
          this.$postHttp('/common/entgroup/info',{}).then((res)=>{
            // console.log(res);
            if(res.data.code==0){
              let data = res.data.list;
              this.allList = data;
            }

          })

        }
    }
</script>
<style scoped lang="scss">
  .mask{
    position: fixed;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    font-size: 0.24rem;
    background:rgba(0,0,0,0.5);
  }
  .rel{
    font-size: 0.28rem;
    ul{
      width: 6.9rem;
      /*height: 3.57rem;*/
      background: #ffffff;
      top: 1.21rem;
      position: absolute;
      left: 0.32rem;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      padding: 0.1rem 0.3rem;
      box-sizing: border-box;
      z-index: 11;
      li{
        height: 0.6rem;
        display: flex;
        align-items: center;
        /*vertical-align: center;*/
      }
      li:hover{
        color:rgba(0,126,255,1);
      }
    }
  }
  #pos{
    top: 4.21rem;
  }
  .active{
    color: rgba(0,126,255,1);
  }
  .search{
    width: 100%;
    height: 1.1rem;
    background:#F7F7F7;
    display: flex;
    align-items: center;
    padding: 0 0.3rem;
    box-sizing: border-box;
    .search_inp{
      width: 4.8rem;
      height: 0.7rem;
      border: 1px solid #DBDBDB;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      background: #ffffff;
      display: flex;
      align-items: center;
      input{
        width:4.21rem;
        border: none;
        padding-left: 0.21rem;
        box-sizing: border-box;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        outline: none;
        font-size: 0.28rem;
        height: 0.7rem;
      }
      input::placeholder{
        font-size: 0.28rem;
      }
      div{
        width: 0.6rem;
        height: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 1px solid #DBDBDB;
        img{
          width: 0.48rem;
          height: 0.48rem;
        }
      }

    }
    .search_type{
      width: 1.8rem;
      display: flex;
      font-size: 0.28rem;
      height: 0.7rem;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      margin-left: 0.29rem;
      background: #ffffff;
      border: 1px solid #DBDBDB;
      z-index: 11;
      span{
        /*display: inline-block;*/
        color: #1B94F5;
        width: 1.2rem;
        height: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      div{
        width: 0.6rem;
        height: 0.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #DBDBDB;
        img{
          width: 0.48rem;
          height: 0.48rem;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/container/search.vue